import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  justify-content: space-between;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      flex-wrap: wrap;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
/**
 * Helper components for constructing flex layouts, can be restyled or contain different variations.
 */

export var Horizontal = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['wrap'].includes(prop);
  }
})(_templateObject(), function (props) {
  return props.wrap && css(_templateObject2());
});
export var Vertical = styled(Horizontal)(_templateObject3());
export var TwoSideRow = styled(Horizontal)(_templateObject4());